// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__2YrQT","infinityPath":"Loader_infinityPath__IymlZ","infinity-spin":"Loader_infinity-spin__+BQUG","infinity-vanish":"Loader_infinity-vanish__NKdmr"};